module.exports = __webpack_public_path__ + "static/media/a4c-residency.cc166581.jpeg";